
import ReportsList from '@/components/reports/ReportsList.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { ReportsList },
});
